/** A record page's immediate action — one that happens on the server at once and is NOT
 *  part of the draft ("Create departure tag now", "Create link now", "Unarchive"), next to
 *  draft edits that wait for Save (PRODUCT "Safety is a feature"). It looks and reads
 *  different from a draft add: a bolt icon (never the draft adds' plus), its label ends in
 *  "now" by convention, and assistive tech hears "happens at once, not part of the draft"
 *  (`aria-description`). Confirm destructive or credential-creating actions behind a
 *  popover or dialog before calling it. */
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import { Button, type ButtonProps } from '@mui/material';
import { forwardRef } from 'react';

export const IMMEDIATE_DESCRIPTION = 'happens at once, not part of the draft';

export type ImmediateActionButtonProps = Omit<ButtonProps, 'startIcon'>;

export const ImmediateActionButton = forwardRef<HTMLButtonElement, ImmediateActionButtonProps>(function ImmediateActionButton(
  { children, size = 'small', ...rest },
  ref,
) {
  return (
    <Button
      ref={ref}
      size={size}
      startIcon={<BoltOutlinedIcon />}
      data-immediate-action
      {...({ 'aria-description': IMMEDIATE_DESCRIPTION } as Record<string, string>)}
      {...rest}
    >
      {children}
    </Button>
  );
});
